import {Injectable} from '@angular/core';
import {ApiService} from "@core/api/api.service";
import { DashboardActivity} from "@data/interefaces/client-portal.interfaces";
import {KpiSidebarItem} from "@shared/ag-kpi-sidebar/ag-kpi-sidebar.component.ds";
import {TimeUnit} from "@data/enums/data.enums";
import {ClientPortalActivityService} from "@data/client-portal/client-portal-activity.service";

@Injectable({
  providedIn: 'root'
})
export class DashboardActivityService {
  private readonly URL = '/v2/api/client-portal/dashboard-activity';
  private readonly TITLE_AVG_LOAD_TIME = "Average Time to Load a Dashboard in Last";
  private readonly KPI_CSS_ID = "dashboard-activity-kpi"

  constructor(private _apiService: ApiService, private _clientPortalActivityService:ClientPortalActivityService) {
  }

  public getAllDashboardActivity(): Promise<DashboardActivity[]> {
    return this._apiService.makeGetServiceCall<DashboardActivity[]>(this.URL);
  }

  // KPIs
  public getDashboardActivityKpi(dashboardActivities: DashboardActivity[], timeUnit: TimeUnit | null): KpiSidebarItem[] {
    if (!timeUnit) {
      timeUnit = TimeUnit.HOUR;
    }

    const kpiItems: KpiSidebarItem[] = [];
    kpiItems.push(this._clientPortalActivityService.getAverageLoadTimeKpi(dashboardActivities, timeUnit, this.TITLE_AVG_LOAD_TIME, this.KPI_CSS_ID));
    return kpiItems;
  }

}
